import { BASE_URL, GET_TOKEN } from "../api/apiUrls";
import Swal from "sweetalert2";
import axios from 'axios'
const handleDownload = (data) => {
  if (!data || data.length === 0) {
    return alert("No data found");
  }

  // Extract headers from the first object
  const headers = Object.keys(data[0]);

  // Convert array of objects to CSV format
  const csvContent = [
    headers.join(","), // CSV Header
    ...data.map((row) =>
      headers
        .map((field) =>
          row[field] !== null && row[field] !== undefined
            ? `"${row[field]}"`
            : ""
        )
        .join(",")
    ), // CSV Rows
  ].join("\n");

  // Create a Blob from the CSV content
  const blob = new Blob([csvContent], { type: "text/csv" });
  const url = URL.createObjectURL(blob);

  // Create a link and trigger the download
  const a = document.createElement("a");
  a.href = url;
  a.download = "streport.csv";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
};

const injectColumnData = (originalQuery, columnData) => {
  // Find the first FROM, capture everything after it
  const fromIndex = originalQuery.toUpperCase().indexOf("FROM");

  if (fromIndex === -1) {
    // No FROM clause, return as-is with SELECT only
    return `SELECT ${columnData}`;
  }

  // Get the rest of the query starting from FROM
  const afterFrom = originalQuery.slice(fromIndex);

  // Final query is SELECT + your columnData + original FROM...rest
  return `SELECT ${columnData} ${afterFrom}`;
};

export const fetchDataByQuery = async (query, columnData, alertMsg) => {
  try {
    const modifiedQuery = injectColumnData(query, columnData);

    console.log(modifiedQuery);
    const result = await Swal.fire({
      title: "Confirm to download?",
      text: alertMsg,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, download it!",
      cancelButtonText: "No, cancel",
    });

    if (!result.isConfirmed) {
      return; // Exit function if user cancels
    }
    const res = await axios.post(
      BASE_URL + "/mondayMeetings/generate-reports",
      {
        mstr: modifiedQuery,
        tokenNumber: GET_TOKEN,
      }
    );
    if (res.status === 200 || res.status === 201) {
      handleDownload(res.data);
    }
  } catch (error) {
    console.log(error.message);
  }
};
export const fetchDataByRawQuery = async (query, alertMsg) => {
  try {
    console.log(query);
    const result = await Swal.fire({
      title: "Confirm to download?",
      text: alertMsg,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, download it!",
      cancelButtonText: "No, cancel",
    });

    if (!result.isConfirmed) {
      return; // Exit function if user cancels
    }
    const res = await axios.post(
      BASE_URL + "/mondayMeetings/generate-reports",
      {
        mstr: query,
        tokenNumber: GET_TOKEN,
      }
    );
    if (res.status === 200 || res.status === 201) {
      handleDownload(res.data);
    }
  } catch (error) {
    console.log(error.message);
  }
};